import React from 'react';
import qgl from 'graphql-tag';
import { GenericFieldSelect, GenericFieldSelectProps } from './fs-genericFieldSelect';
import { useLazyQuery } from '@apollo/client';

// The queries are defined here and passed as props to the GenericFieldSelect component in the respective FieldSelect components.
const GET_CONTAINERORDERSTATES = qgl`
query getContainerorderStates($where: String, $offset: Int, $limit: Int, $order: String) {
    getContainerorderStates(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;
const GET_CONTAINERORDERTYPES = qgl`
query getContainerordertypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getContainerordertypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;
export const GET_CONTAINERTYPES = qgl`
query getContainertypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getContainertypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;
const GET_USERTYPES = qgl`
query getUserTypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getUserTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;
//hooks for forms
export const useGetContainerTypes = () => {
  return useLazyQuery(GET_CONTAINERTYPES, { fetchPolicy: 'cache-first' });
};
// The FieldSelect components are defined here and passed the respective query as a prop.
export const FieldSelectContainerOrderState = (props: Omit<GenericFieldSelectProps, 'query'>) => (
  <GenericFieldSelect {...props} query={GET_CONTAINERORDERSTATES} />
);
export const FieldSelectContainerOrderType = (props: Omit<GenericFieldSelectProps, 'query'>) => (
  <GenericFieldSelect {...props} query={GET_CONTAINERORDERTYPES} />
);
export const FieldSelectContainerType = (props: Omit<GenericFieldSelectProps, 'query'>) => (
  <GenericFieldSelect {...props} query={GET_CONTAINERTYPES} />
);
// export const FieldSelectUserType = (props: Omit<GenericFieldSelectProps, 'query'>) => (
//   <GenericFieldSelect {...props} query={GET_USERTYPES} />
// );

